import { Loader2 } from "lucide-react";

export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="flex flex-col items-center space-y-3">
        <Loader2 className="h-12 w-12 text-primary animate-spin drop-shadow-lg" />
      </div>
    </div>
  );
}
